import type { Quiz } from '@efdigital/ll-addon-data';
import { DataTypeQuiz } from '@efdigital/ll-addon-data/data-types';
import { findRecord } from '@warp-drive/utilities/json-api';

import { jsonApiOptions } from '../../json-api.ts';

export function findQuizById(quizId: string) {
  return findRecord<Quiz>(DataTypeQuiz.Quiz, quizId, jsonApiOptions);
}
